import React from "react";
import { injectIntl, intlShape } from "@edx/frontend-platform/i18n";
import { Dropdown } from "@openedx/paragon";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { getConfig } from "@edx/frontend-platform";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import dummyImage from "../../images/dummyImage.png";
import { timeAgo } from "../../utils/utility";
import { updateNotifications } from "../../data/api";
import { useNotifications } from "./useNotifications";
import { fetchNotificationsData } from "../../data/thunks";
import {
  NOTIFICATION_TYPES,
  APPROVAL_REQUEST_STATUS,
  TOASTMASTERS_WEBSITE_URL,
} from "../../config";

function NotificationItem({ notification, shouldOpenModal }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    notificationText,
    redirectRoute,
    notificationType,
    isSenderReceiver,
    displayName,
    status,
    shouldRedirectToToastmasterWebsite,
  } = useNotifications(notification, shouldOpenModal);

  const handleClick = () => {
    (async () => {
      await updateNotifications(notification.slug);
      dispatch(fetchNotificationsData());
    })();

    if (status === APPROVAL_REQUEST_STATUS.Reversed) {
      toast.info(
        "The request has become obsolete. The learner's progress may have been reversed. For further information, please reach out to our support team."
      );

      return;
    }

    if (shouldRedirectToToastmasterWebsite) {
      window.location.assign(TOASTMASTERS_WEBSITE_URL);
      return;
    }

    if (!redirectRoute) {
      return;
    }

    if (
      NOTIFICATION_TYPES.pathwaysMentorProgramEnrollment === notificationType ||
      NOTIFICATION_TYPES.clubCoachModuleEnrollment === notificationType ||
      NOTIFICATION_TYPES.courseInactivity === notificationType ||
      NOTIFICATION_TYPES.courseEnrollment === notificationType ||
      (notificationType === NOTIFICATION_TYPES.completionReviewNotifyBCM &&
        isSenderReceiver)
    ) {
      navigate(redirectRoute, { replace: true });
    } else {
      window.location.assign(redirectRoute);
    }
  };

  const courseImageNotificationTypes = [
    NOTIFICATION_TYPES.pathwaysMentorProgramEnrollment,
    NOTIFICATION_TYPES.courseInactivity,
    NOTIFICATION_TYPES.completionRequestSecondReminder,
    NOTIFICATION_TYPES.completionRequestFirstReminder,
    NOTIFICATION_TYPES.preCourseEnrollment,
    NOTIFICATION_TYPES.completionReview,
    NOTIFICATION_TYPES.completionRequest,
    NOTIFICATION_TYPES.courseEnrollment,
    NOTIFICATION_TYPES.completionReviewNotifyBCM,
  ];

  return (
    <Dropdown.Item onClick={handleClick}>
      <div className="user-image">
        <img
          alt="Image"
          src={
            courseImageNotificationTypes.includes(notificationType)
              ? getConfig().LMS_BASE_URL + notification?.target?.courseImage
              : notification?.sender?.memberPhotoUrl
          }
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = dummyImage;
          }}
        />
      </div>
      <div className="notification-text">
        <div className="notification-row-header">
          <h4 className="fw-700 text-capitalize">{displayName}</h4>
          <span className="fw-700 notify-timestamp">
            {timeAgo(notification.timestamp)}
          </span>
        </div>
        <div>
          <div dangerouslySetInnerHTML={{ __html: notificationText }}></div>
        </div>
      </div>
    </Dropdown.Item>
  );
}

NotificationItem.propTypes = {
  intl: intlShape.isRequired,
  notification: PropTypes.object.isRequired,
};

export default injectIntl(NotificationItem);
